<mat-form-field class="w-100" [tcTooltip]="tooltipText" [placement]="tooltipPlacement">
    <mat-label>{{ name }}</mat-label>
    <input
        matInput
        [type]="isPassword ? 'password' : 'text'"
        [(ngModel)]="value"
        #control="ngModel"
        (ngModelChange)="_onChangeCallback($event)"
        (blur)="_onTouchedCallback()"
        autocomplete="off"
        [pattern]="pattern"
        [required]="isRequired"
        [disabled]="isDisabled"
        [readonly]="isReadonly"
        [minlength]="minLength"
        [maxlength]="maxLength"
        [iban]="isIban"
        [email]="email"
    />
    <mat-error *ngIf="control.hasError('iban')">
        {{ 'terraTextInput.invalidIban' | translate: _locale.language }}
    </mat-error>
    <mat-error *ngIf="control.hasError('maxlength')">
        {{ 'validators.maxLength' | translate: _locale.language:{ maxLength: maxLength } }}
    </mat-error>
    <mat-error *ngIf="control.hasError('minlength')">
        {{ 'validators.minLength' | translate: _locale.language:{ minLength: minLength } }}
    </mat-error>
    <mat-error *ngIf="control.hasError('email')">
        {{ 'terraTextInput.invalidEmail' | translate: _locale.language }}
    </mat-error>
    <mat-error *ngIf="control.hasError('required')">
        {{ 'validators.required' | translate: _locale.language }}
    </mat-error>
    <mat-error *ngIf="control.hasError('pattern')">
        {{ 'validators.pattern' | translate: _locale.language:{ pattern: pattern } }}
    </mat-error>
</mat-form-field>
